import { Promise } from 'rsvp';
import Service, { inject as service } from '@ember/service';
import { handleErrorResponseWithModal } from 'sh-www/utils/handles-errors';

/**
 * Service for sh-invoice-transaction API calls
 */
export default Service.extend({
  api: service(),
  shData: service(),

  /**
   * Add an invoice transaction item
   *
   * @param {ShInvoice} shInvoice
   * @param {Number} amount
   * @param {String} processorType     of type ShInvoice.PROCESSORS.*
   * @param {String} processorAccountId
   * @param {String} processorTransactionId
   * @param {Number} creditCostCodeId
   * @param {String} integrityChecksum
   * @return {Ember.RSVP.Promise}
   */
  addTransaction({
    shInvoice,
    processorType,
    amount,
    processorAccountId = null,
    processorTransactionId = null,
    creditCostCodeId = null,
    integrityChecksum = null,
  } = {}) {
    const options = {
      jsonData: {
        processor: processorType,
        amount,
      },
    };

    if (creditCostCodeId) {
      options.jsonData.credit_cost_code_id = creditCostCodeId;
    }

    if (processorAccountId) {
      options.jsonData.processor_account_id = processorAccountId;
    }

    if (processorTransactionId) {
      options.jsonData.processor_transaction_id = processorTransactionId;
    }

    if (integrityChecksum) {
      options.jsonData.integrity_checksum = integrityChecksum;
    }

    this.shData.addIncludesToOptions(options, []);

    return this.api.post(`sh-invoices/${shInvoice.id}/sh-invoice-transactions`, options);
  },

  /**
   * Edit an invoice transaction item
   *
   * @param {ShInvoiceTransaction} shInvoiceTransaction
   * @param {Number} amount
   * @param {String} processorType     of type ShInvoice.PROCESSORS.*
   * @param {String} processorAccountId
   * @param {String} processorTransactionId
   * @return {Ember.RSVP.Promise}
   */
  editTransaction(shInvoiceTransaction, amount, processorType, processorAccountId, processorTransactionId) {
    let options = {
      jsonData: {
        'amount' : amount,
        'processor' : processorType,
        'processor_account_id' : processorAccountId,
        'processor_transaction_id' : processorTransactionId
      }
    };

    this.shData.addIncludesToOptions(options, []);

    return new Promise((resolve, reject) => {
      this.get('api').put(
        `sh-invoice-transactions/${shInvoiceTransaction.get('id')}`,
        options
      ).then(response => {
        this.shData.pushResponseToStore(response);
        resolve(shInvoiceTransaction);
      }).catch(e => {
        handleErrorResponseWithModal(
          this,
          e,
          'There was an error editing the transaction. Please refresh and try again.',
          'editTransaction -- error editing invoice transaction for invoice id : ' + shInvoiceTransaction.get('id'),
        );
        reject(e);
      });
    });
  },

  /**
   * @param {ShInvoiceTransaction} shInvoiceTransaction
   * @return {Promise<*>}
   */
  deleteTransaction(shInvoiceTransaction) {
    return this.get('api').delete(`sh-invoice-transactions/${shInvoiceTransaction.get('id')}`);
  },
});
